<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="fixed inset-0 z-50 flex items-center justify-center"
      style="z-index: 100000;"
    >
      <div
        class="absolute inset-0 bg-gray-500 opacity-75"
        @click="handleClose"
      ></div>
      <div
        class="relative z-10 w-full max-w-md rounded-2xl bg-white px-8 py-7 shadow-2xl text-center"
        role="dialog"
        aria-modal="true"
      >
        <button
          type="button"
          class="absolute right-4 top-4 text-gray-400 hover:text-gray-600 focus:outline-none"
          @click="handleClose"
          aria-label="Close feedback modal"
        >
          <svg
            class="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h3 class="text-xl font-semibold text-gray-900">
          {{ title }}
        </h3>
        <p class="mt-2 text-base text-gray-600">
          {{ message }}
        </p>
        <div
          class="mt-6 flex items-center justify-center gap-6"
          v-if="showEmojiPicker"
        >
          <button
            v-for="option in options"
            :key="option.value"
            type="button"
            class="flex h-20 w-20 items-center justify-center rounded-full bg-white shadow-md ring-1 ring-gray-100 transition hover:-translate-y-0.5 hover:ring-primary"
            @click="handleSelect(option.value)"
            :aria-label="option.label"
          >
            <span class="text-4xl leading-none">
              {{ option.icon }}
            </span>
          </button>
        </div>
        <div v-if="showFeedbackForm" class="mt-6 text-left">
          <label class="block text-sm font-medium text-gray-700">
            We'd love to know what went wrong
          </label>
          <textarea
            v-model.trim="feedbackText"
            rows="4"
            class="mt-2 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-900 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
            placeholder="Share your feedback here..."
          ></textarea>
          <div class="mt-4 flex items-center justify-end gap-3">
            <button
              type="button"
              class="text-sm font-medium text-gray-500 hover:text-gray-700"
              @click="cancelFeedback"
            >
              Skip
            </button>
            <button
              type="button"
              class="rounded-lg bg-indigo-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-indigo-500 disabled:cursor-not-allowed disabled:opacity-70"
              :disabled="!feedbackText"
              @click="submitFeedback"
            >
              Send feedback
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "FeedbackModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "How's it going so far?"
    },
    message: {
      type: String,
      default:
        "Is Carthike: WhatsApp App doing what you need? Click an emoji to tell us!"
    }
  },
  emits: ["close", "submit"],
  data() {
    return {
      showFeedbackForm: false,
      showEmojiPicker: true,
      feedbackText: "",
      selectedOption: null,
      options: [
        { value: "positive", label: "Share positive feedback", icon: "👍" },
        { value: "negative", label: "Share negative feedback", icon: "👎" }
      ]
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
    async handleSelect(value) {
      if (value === "negative") {
        this.selectedOption = value;
        this.showFeedbackForm = true;
        this.showEmojiPicker = false;
        return;
      }
      if (value === "positive") {
        this.selectedOption = value;
        this.showEmojiPicker = false;
        this.handleClose();
        try {
          // eslint-disable-next-line
          const result = await shopify.reviews.request();
          if (!result.success) {
            console.log(
              `Review modal not displayed. Reason: ${result.code}: ${result.message}`
            );
          }
          // if result.success *is* true, then review modal is displayed
        } catch (error) {
          console.error("Error requesting review:", error);
        }

        return;
      }
    },
    cancelFeedback() {
      this.showFeedbackForm = false;
      this.feedbackText = "";
      this.selectedOption = null;
      this.$emit("submit", { sentiment: "negative", feedbackProvided: false });
      this.handleClose();
    },
    submitFeedback() {
      if (!this.feedbackText) {
        return;
      }
      const payload = {
        sentiment: "negative",
        feedback: this.feedbackText
      };
      this.sendFeedbackToCrisp(this.feedbackText);
      this.$emit("submit", payload);
      this.feedbackText = "";
      this.showFeedbackForm = false;
      this.selectedOption = null;
      this.handleClose();
    },
    sendFeedbackToCrisp(message) {
      // eslint-disable-next-line no-undef
      if (typeof $crisp !== "undefined") {
        // eslint-disable-next-line no-undef
        $crisp.push([
          "do",
          "message:send",
          ["text", `Feedback from in-app modal:\n\n${message}`]
        ]);
      }
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
